import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { BLOG_RESEARCH_AGENT_SUNSET_DATE_MS } from 'marketplace-ui-common/constants/Agents';
import { getIsBlogResearchAgentListing } from 'marketplace-ui-common/utils/agents';
import { jsx as _jsx } from "react/jsx-runtime";
export function BlogResearchAgentSunsetBanner({
  listingSlug
}) {
  if (!getIsBlogResearchAgentListing(listingSlug)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    marginBlockEnd: "600",
    type: "info",
    closeable: false,
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "detailsPage.blogResearchAgentSunsetBanner.message_jsx",
      elements: {
        Date: FormattedDateTime
      },
      options: {
        format: 'LL',
        type: 'utc',
        value: BLOG_RESEARCH_AGENT_SUNSET_DATE_MS
      }
    })
  });
}